export default __webpack_public_path__ + "static/media/1.09eafad0.png";